"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../hooks");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _Button = require("../../Button");
var _Icon = require("../../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ToggleButton = props => {
  const {
    direction
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    btnIconName,
    btnProps,
    isOpen,
    isWithTransition,
    onClick
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const size = btnProps?.size || (isMobileView && !isOpen ? 'medium' : 'x-large');
  const iconSize = size === 'x-small' || size === 'small' ? '80%' : '70%';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
    shape: "round",
    view: "alternate",
    size: size,
    customStyle: {
      transition: isWithTransition ? 'width 0.5s ease-in-out,  height 0.5s ease-in-out' : 'none',
      transform: direction === 'rtl' ? 'none' : 'scaleX(-1)'
    },
    ...btnProps,
    id: btnProps?.id ? `ccExpandableToggleButton-${btnProps.id}` : 'ccExpandableToggleButton',
    onClick: onClick,
    children: btnIconName && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      name: btnIconName,
      width: iconSize,
      height: iconSize
    })
  });
};
exports.ToggleButton = ToggleButton;